import styled from "styled-components";

export const Container = styled.section`
    margin-top: 12rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 2rem;

    h2 {
        font-size: 3rem;
        color: ${({ theme }) => theme.primaryText};
        margin-bottom: 2rem;
        transition: color 0.3s ease-in-out;
    }

    .timeline {
        width: 100%;
        position: relative;
    }

    .timeline-item {
        position: relative;
        margin-left: 50px;
        margin-bottom: 30px;
        padding-left: 40px;
        display: flex;
        align-items: center;
    }

    .timeline-dot {
        position: absolute;
        left: 0;
        width: 15px;
        height: 15px;
        background-color: ${({ theme }) => theme.accent};
        border-radius: 50%;
        box-shadow: 0 0 10px ${({ theme }) => theme.shadow};
        transition: background-color 0.3s ease-in-out;
    }

    .timeline-content {
        padding-left: 20px;
        border-left: 2px solid ${({ theme }) => theme.accent};
        padding-bottom: 10px;
        transition: border-left 0.3s ease-in-out;
    }

    .title {
        font-size: 1.8rem;
        font-weight: bold;
        color: ${({ theme }) => theme.primaryText};
        //transition: color 0.3s ease-in-out;
    }

    .institution,
    .company,
    .year,
    .score {
        font-size: 1.4rem;
        color: ${({ theme }) => theme.secondaryText};
        //transition: color 0.3s ease-in-out;
    }

    .year {
        margin-top: 5px;
        font-weight: bold;
        color: ${({ theme }) => theme.accent};
    }

    .timeline-item:last-child .timeline-dot {
        display: none; /* Hide dot on the last item */
    }

    @media (max-width: 960px) {
        .timeline {
            display: block;
        }
    }

    @media (max-width: 480px) {
        .timeline {
            margin-top: 2rem;
        }
    }
`;
